import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=3927f3c9&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"
import style1 from "./ApplicationView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927f3c9",
  null
  
)

export default component.exports